import * as React from "react";
import type { SVGProps } from "react";
const SvgTickCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m3.585-9.165a.562.562 0 1 0-.795-.795l-3.727 3.727L6.21 8.415a.563.563 0 0 0-.795.795l2.25 2.25c.22.22.576.22.795 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTickCircle;
